module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.fill_info == '' && _vm.hianypotlas_fields.length > 0) ? _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("SZE oktatói, kutatói utánpótlás és hallgatói kiválóság ösztöndíj hiánypótlás")]), _vm._v(" "), (_vm.blockTitleShow(['nyelvtudas'])) ? _c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Nyelvtudás\n          ")]) : _vm._e(), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "nyelvtudas",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), (_vm.blockTitleShow(['mellekletek'])) ? _c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Mellékletek\n          ")]) : _vm._e(), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "mellekletek",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), (_vm.blockTitleShow(['otdk', 'hazi_tmdk', 'egyeb_szakmai_tanulmanyi_versenyek', 'egyeb_kiemelkedo_szakmai_tevekenyseg', 'egyeb_szakmai_tevekenyseg', 'megjelent_publikaciok_mtmt_lista_alapjan', 'reszesult_osztondijban_mtmt'])) ? _c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Opcionális\n          ")]) : _vm._e(), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "otdk",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "hazi_tmdk",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "egyeb_szakmai_tanulmanyi_versenyek",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "egyeb_kiemelkedo_szakmai_tevekenyseg",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "egyeb_szakmai_tevekenyseg",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "megjelent_publikaciok_mtmt_lista_alapjan",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "reszesult_osztondijban_mtmt",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Hiánypótlás beküldése")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("SZE oktatói, kutatói utánpótlás és hallgatói kiválóság ösztöndíj hiánypótlás")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, [_vm._v("\n            " + _vm._s(_vm.fill_info) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        SZE oktatói, kutatói utánpótlás és hallgatói kiválóság ösztöndíj\n        "), _c('span', [_vm._v("Hiánypótlás")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-126c6fd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/utanpotlas_hallgatoi_osztondij_hianypotlas.vue
// module id = 329
// module chunks = 0